import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-slide-wysiwyg-header',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './wysiwyg-header.component.html',
    styleUrls: ['./wysiwyg-header.component.scss'],
    standalone: false
})
export class WysiwygHeaderComponent {
  #isSubmitted = signal(false);
  #page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training | null = null;
  headerForm = new FormGroup(
    {
      header: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.PageEntityModels.SlideSchema.pick({
          header: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade) {
    // Update Page
    this.nodeSharedFacade.currentSelectedPage$.pipe(takeUntilDestroyed()).subscribe((page) => {
      if (page?.type !== 'Slide' && page?.type !== 'Training') return;
      this.#page = structuredClone(page);
      if (this.#page) {
        this.headerForm.reset({header: this.#page.header || ''});
      }
      this.#isSubmitted.set(false);
    });
  }

  onSubmit() {
    if (this.#isSubmitted() || this.headerForm.invalid || !this.#page) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Page
    const page = assign(this.#page, {
      header: this.headerForm.value['header']
    });
    this.nodeSharedFacade.requestUpdatePage(page, 'history.page_update_header').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.headerForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
